<template>
    <div class="d-flex flex-column gap-6" data-testid="workflow-bulk-edit__root">
        <Breadcrumbs
            :glCodeText="breadcrumbCycleLabel"
            :glCodeInfo="cycleBreadcrumbText"
            :activeCommentary="{}"
            :getStatusLabel="getStatusLabel"
            :isRefreshing="isRefreshing"
            :reportingType="'pl'"
            @back="goBack"
            @refresh="handleEmptyRefresh"
            data-testid="workflow-bulk-edit__breadcrumbs"
            :showRefresh="false"
        />

        <CountSection class="gap-120"
            data-testid="workflow-bulk-edit__features-count-section" 
            :count="selectedIds.length" 
            :networkLabel="'Selected'" 
            :countLabel="'RUs'" 
        />

        <v-card class="pa-3" outlined data-testid="workflow-bulk-edit__card">
             <div v-if="selectedIds.length === 0" class="pa-4 text-center">
                No items selected.
            </div>
            <WorkflowConfigTab 
                v-else
                class="pt-3" 
                :detail="detail" 
                :is-bulk-mode="true"
                :selected-ids="selectedIds"
                :selected-details="selectedDetails"
                @refresh="handleSuccess" 
            />
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Breadcrumbs from '../../../components/Breadcrumbs.vue';
import WorkflowConfigTab from './WorkflowConfigTab.vue';
import CountSection from '../../GlSelection/CountSection.vue';

export default {
    name: 'WorkflowBulkEdit',
    components: {
        Breadcrumbs,
        WorkflowConfigTab,
        CountSection
    },
    props: {
        ids: {
            type: Array,
            default: () => []
        },
        selectedDetails: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            breadcrumbCycleLabel: 'Workflow Configuration',
            isRefreshing: false,
            mockDetail: {
                code: 'BULK',
                _id: 'BULK_MULTI_EDIT'
            }
        };
    },
    computed: {
        ...mapGetters('varianceanalysis/reportingUnit', ['getRUDetail']),
        selectedIds() {
            if (this.ids && this.ids.length > 0) return this.ids;
            
            const ids = this.$route.query.ids;
            if (!ids) return [];
            return ids.split(',').filter(Boolean);
        },
        cycleBreadcrumbText() {
            return `Edit Workflow`;
        },
        // In bulk mode, we might not have a single "detail" to show,
        // but if validation or logic in child depends on it, we can proxy one from store if needed
        // or keep using mockDetail if it's purely for bulk update structure.
        // However, user asked for API call.
        detail() {
             return this.getRUDetail || this.mockDetail;
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        ...mapActions('varianceanalysis/reportingUnit', ['fetchRUDetail']),
        
        async fetchData() {
            // Even though we have multiple IDs, we might need to fetch at least one 
            // to satisfy the child component's expectations or to get common metadata.
            // If the intention is just "Do what WorkflowEditDetails does", we can fetch the first one.
            // Or if the backend supports bulk fetch, we'd use that.
            // Assuming we fetch the first one to populate 'getRUDetail' so the child component receives valid data.
            
            if (this.selectedIds.length === 0) return;

            this.isRefreshing = true;
            try {
                // Fetching the first ID's details to populate the store/state
                // This ensures WorkflowConfigTab receives a valid object from 'getRUDetail' 
                // just like in the single edit page.
                await this.fetchRUDetail({
                    filter: { reportingunit: [this.selectedIds[0]] },
                    axiosInstance: this.axios
                });
            } catch (error) {
                console.error("Failed to fetch RU details for bulk edit", error);
            } finally {
                this.isRefreshing = false;
            }
        },

        getStatusLabel(key, fallback) {
            return fallback || key;
        },
        goBack() {
             if (this.ids && this.ids.length > 0) {
                 this.$emit('back'); 
             } else {
                 this.$nova.gotoLink({
                    path: '/varianceanalysis/workflow'
                });
             }
        },
        handleSuccess() {
            this.goBack();
        },
        handleEmptyRefresh() {
            // No-op for bulk edit
        }
    }
};
</script>
